import React from 'react';

export default function NetworkQualityLevel({ qualityLevel }) {

    if (qualityLevel === null || qualityLevel === 0) return null;
    
    let backgroundClass = "";
    switch (qualityLevel) {
        case 5:
        case 4: 
            backgroundClass = "green";
            break;                  
        case 3:
            backgroundClass = "orange";
            break;
        case 1:
        case 2:
            backgroundClass = "red";
            break;
        default:
            backgroundClass = ""; 
    }

    return (
        <div className={`network-quality-container ${backgroundClass}`}>         
          {[0, 1, 2, 3, 4].map(level => (
              <div key={level} className={`bar ${qualityLevel > level ? 'filled' : 'empty'}`} />
          ))}
      </div>
  );
}
